<link rel=stylesheet href="https://cdn.jsdelivr.net/npm/pretty-print-json@1.2/dist/pretty-print-json.css">
<code>
  <pre id="data" class=json-container> </pre>
</code>